var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',{staticClass:"mapSwitch"},_vm._l((_vm.mapSwitchNav),function(item,index){return _c('li',{key:index,class:index === _vm.activeIndex ? 'active' : '',on:{"click":function($event){return _vm.mapSwitchClick(index)}}},[_c('div',[_c('img',{attrs:{"src":`/image/${index}.png`,"alt":""}})]),_c('div',[_vm._v(_vm._s(item))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }